import { render, staticRenderFns } from "./EstablishmentContact.vue?vue&type=template&id=2cd58a4f&scoped=true"
import script from "./EstablishmentContact.vue?vue&type=script&lang=js"
export * from "./EstablishmentContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd58a4f",
  null
  
)

export default component.exports